//TODO: combine this with lib/utils and/or separate into individual services

// Make sure that the request headers are set correctly before
// ajax send.
$(function() {
  $.ajaxSetup({
    beforeSend: function(xhr) {
      xhr.setRequestHeader('accept', 'application/json');
      if(i18next.language) {
        // also see app/extentions for the fetch shim
        xhr.setRequestHeader('Accept-Language', `${i18next.language};q=1.0`);
      }
    }
  });
});

// Date.now poly
Date.now = Date.now || function() { return +new Date(); };


// Orientation detection passthrough.
// Listen for EF.on('orientationchange') to get notifications. Pull
// orientation value off of EF.orientation;
//
EF.orientation = window.orientation;

if(window.addEventListener && EF && EF.config) {
  if(window.top !== window) {
    window.addEventListener('message', function(message) {
      var originMatch = (message.origin === EF.config.get('basePath'));
      if(originMatch && message.data.type == 'orientationchange') {
        EF.orientation = message.data.orientation;
        EF.trigger('orientationchange', message.data.orientation);
      }
    }, false);
  }
  else {
    window.addEventListener('orientationchange', function() {
      EF.orientation = window.orientation;
      EF.trigger('orientationchange', window.orientation);
    }, false);
  }
}

window.LocalStorageWrapper = {
  getItem: function ls_getItem(key) {
    try {
      return localStorage.getItem(key);
    } catch(e) {
      // eslint-disable-next-line no-console
      console.error(e);
      return ObjectStore.getItem(key);
    }
  },

  setItem: function ls_setItem(key, value) {
    try {
      return localStorage.setItem(key, value);
    } catch(e) {
      // eslint-disable-next-line no-console
      console.error(e);
      return ObjectStore.setItem(key, value);
    }
  },

  removeItem: function ls_removeItem(key) {
    try {
      return localStorage.removeItem(key);
    } catch(e) {
      ObjectStore.removeItem(key);
    }
  },

  clear: function ls_clear() {
    try {
      localStorage.clear();
    } catch(e) {
      // eslint-disable-next-line no-console
      console.error(e);
      ObjectStore.clear();
    }
  }
};

const ObjectStore = {
  store: {},
  getItem: function get_Item(key) {
    return this.store[key];
  },

  setItem: function set_Item(key, value) {
    this.store[key] = value;
    return value;
  },

  removeItem: function os_removeItem(key) {
    if(Object.prototype.hasOwnProperty.call(this.store, key)) {
      return delete this.store[key];
    }
  },
  clear: function os_clear() {
    this.store = {};
  }
};

window.UrlHelper = function() {
  this.params = this.params || (function() {
    var varArray = window.location.search.replace('?', '').split('&');
    return varArray.reduce(
      function(searchObj, param) {
        var paramValues = param.split('=');
        var key = paramValues[0];
        var value = paramValues[1];
        searchObj[key] = value;
        return searchObj;
      }, {});
  })();
};

window.UrlHelper.prototype = {
  getParam: function(key, defaultKey) {
    return this.params[key] || defaultKey;
  },

  buildEnrollment: function(enrollmentHash) {
    var attrs = ['id', 'userId', 'cohortId', 'schoolId', 'name', 'schoolName', 'className', 'state', 'certified'];
    enrollmentHash =  _.defaults(_.pick(this.params,  attrs), enrollmentHash);
    return new EF.Models.Enrollment(enrollmentHash);
  },

  buildConfig: function(moreAttrs) {
    var attrs = ['assessmentEndpoint', 'basePath', 'stage', 'demoMode'];
    var config =  _.defaults(_.pick(this.params,  attrs), moreAttrs);
    return new EF.Config(config);
  },

  buildOptions: function(moreAttrs) {
    var attrs = ['pmMode', 'sandboxMode', 'local', 'apiOnly', 'loadCustomizationsRemote'];
    return _.defaults(_.pick(this.params,  attrs), moreAttrs);
  }
};

window.SandboxHelper = function(sandboxTarget, sandboxOrigin) {
  this.sandboxTarget = sandboxTarget || window.top;
  this.sandboxOrigin = sandboxOrigin || EF.config.get('basePath');

  var self = this;

  EF.on('ready', function() {
    self.postEnrollment();
    self.postConfig();
    self.postOptions();
  });

  EF.on('module:load', function(module) {
    self.postNotification('Loading Module: ' + module.get('key'));
  });

  EF.on('module:start', function(page) {
    self.postNotification('Starting Module: ' + page.moduleKey);
  });

  EF.on('module:complete', function(module) {
    self.postNotification('Completed Module: ' + module.get('key'));
  });

  EF.on('activity:load', function(activity) {
    self.postNotification('Loading Activity: ' + activity.get('key'));
  });

  EF.on('activity:start', function(page) {
    self.postNotification('Starting Activity: ' + page.activityKey);
    self.postPage(page);
  });

  EF.on('activity:complete', function(activity) {
    self.postNotification('Completed Activity: ' + activity.get('key'));
    self.postActivity(activity);
  });

  EF.on('contentPage:loaded', function(page) {
    self.postNotification('Loading ContentPage: ' + page.key);
    self.postContentPage(page);
  });

  EF.on('contentPage:notLoaded', function(contentPageKey) {
    self.postNotification('Could Not Load ContentPage: ' + contentPageKey);
  });

  EF.on('page:completed', function(page) {
    self.postNotification('Completed Page: ' + page.get('key'));
    self.postPage(page);
  });

  EF.on('module:progress:set', function(module) {
    self.postNotification('Setting Progress for Module: ' + module.get('key') );
  });

  EF.on('modulesProgress:loaded', function() {
    self.postNotification('All Module Progress is Loaded and Set');
    self.postModules();
  });

  EF.on('pageProgress:saved', function(pageProgress) {
    self.postPageProgress(pageProgress, 'saved');
  });

  EF.on('activityProgress:saved', function() {
   self.postActivityProgress(EF.module, 'saved');
 });

  EF.on('activityProgress:failed', function() {
   self.postActivityProgress(EF.module, 'failed');
 });
};

window.SandboxHelper.prototype = {
  postToSandbox: function(message, obj) {
    var data = { sbMessage: message, obj: JSON.stringify(obj) };
    this.sandboxTarget.postMessage(data, this.sandboxOrigin);
  },

  postPageProgress: function(pageProgress, status) {
    var data = { key: pageProgress.key, pageData: pageProgress.data, status: status };
    this.postNotification('Page Progress for ' + pageProgress.key + ': ' + status);
    this.postToSandbox('sbPageProgress', data);
  },

  postDynamicHeight: function() {
    this.postToSandbox('sbLayoutHeight', $('html').height());
  },

  postContentPage: function(contentPage) {
    this.postToSandbox('sbContentPage', contentPage);
  },

  postActivity: function(activity) {
    this.postToSandbox('sbActivity', activity);
  },

  postPage: function(page) {
    // var data = { key: page.key, activityKey: page.activityKey, moduleKey: page.moduleKey, pageData: page.pageData, completed: page.completed };
    this.postToSandbox('sbPage', page);
  },

  postModules: function() {
    this.postToSandbox('sbModules', EF.modules);
  },

  postActivityProgress: function(module, status) {
    // var data = { key: module.get("key"), status: status };
    this.postNotification('Activity Progress for ' + module.get('key') + ': ' + module.get('status'));
    this.postToSandbox('sbActivityProgress', { module: module, key: module.get('key'), status: status });
  },

  postEnrollment: function() {
    this.postToSandbox('sbEnrollment', EF.enrollment);
  },

  postConfig: function() {
    var safeConfig = EF.config.getAll();
    if(safeConfig.stage instanceof $) {
     safeConfig.stage = safeConfig.stage.id;
   }
   this.postToSandbox('sbConfig', safeConfig);
 },

 postOptions: function() {
  this.postToSandbox('sbOptions', EF.options);
},

postNotification: function(notification) {
  var pm = 'AM';
  var currentDate = new Date();
  var hours = currentDate.getHours();
  if(hours > 12) {
    hours = hours - 12;
    pm = 'PM';
  }
  var minutes = currentDate.getMinutes();
  var seconds = currentDate.getSeconds();
  if(minutes < 10) minutes = '0' + minutes;
  if(seconds < 10) seconds = '0' + seconds;
  if(hours < 10) hours = '0' + hours;
  var timeString = (hours + ':' + minutes + ':' + seconds + ' ' + pm + ': ');
  var data = {text: notification, timeString: timeString};
  this.postToSandbox('sbNotification', data);
}

};

export { ObjectStore };